import { useRef, useState } from "react";
import { api, API_BASE, openDownload } from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileDown } from "lucide-react";

export default function ImportButton({ kind, label, onDone }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef();

  const importFile = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post(`/import/${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      const failedText = data.failed ? `, ${data.failed} hata` : "";
      toast.success(`${data.imported} kayıt eklendi${failedText}`);
      if (data.errors?.length) console.warn("Import errors:", data.errors);
      if (onDone) onDone();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "İçe aktarma başarısız");
    }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };

  const downloadTemplate = () => {
    const token = localStorage.getItem("madymark_token");
    openDownload(`/api/import/template/${kind}.xlsx`);
  };

  return (
    <div className="flex items-center gap-2">
      <button data-testid={`import-tpl-${kind}`} type="button" onClick={downloadTemplate} title="Şablon indir"
        className="p-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-[#29B7E3] text-slate-500 hover:text-[#1E2A9C] transition">
        <FileDown className="w-4 h-4" />
      </button>
      <button data-testid={`import-btn-${kind}`} type="button" onClick={() => ref.current?.click()} disabled={busy}
        className="flex items-center gap-2 px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:border-emerald-500 text-slate-700 dark:text-slate-200 hover:text-emerald-600 font-bold transition disabled:opacity-60">
        <Upload className="w-4 h-4" /> {busy ? "Yükleniyor..." : (label || "Excel'den İçe Aktar")}
      </button>
      <input ref={ref} type="file" accept=".xlsx" className="hidden" onChange={(e) => e.target.files?.[0] && importFile(e.target.files[0])} />
    </div>
  );
}
